import { STATUS_CODES } from 'http';
import { environment } from '../environments/environment';

export const API_ENDPOINTS = {
	//#region AUTH
	USER_LOGIN: '/OAuth/AuthLogin',

	// USER_LOGIN: '/OAuth/Login',
	USER_LOGOUT: '/OAuth/Logout',
	FORGOT_PASSWORD: '/OAuth/ForGotPassword',
	CHANGE_PASSWORD: '/OAuth/ChangePassword',
	VERIFY_OTP: '/OAuth/VerifyOTP',
	APP_REFRESH_TOKEN: '/OAuth/RefreshToken',
	INFLUENCER_VERIFY_OTP: '/OAuth/AuthInfluencer',
	//#endregion

	GET_TOKEN_SPEECH: '/ChatBot/GetSpeechToken',
	GET_HISTORY_CHATS:'/ChatBot/GetUserChatSession',
	GET_NEW_CHAT:'/ChatBot/NewChatSession',
	CHAT_POST: '/ChatBot/Chat',	
	SPECIFIC_CHAT:'ChatBot/GetChats',
	CHAT_FEEDBACK:'ChatBot/ChatFeedback',
	CHAT_EDIT:'ChatBot/DeleteChatSession',
	RENAME_CHAT:'/ChatBot/RenameSession',

	STATUS_CHECK:'/Status/Check',
	CONNECTION:'/OAuth/CheckConnection'
};
